import { render, staticRenderFns } from "./ValidateCode.vue?vue&type=template&id=1b570ba3&scoped=true"
import script from "./ValidateCode.vue?vue&type=script&lang=js"
export * from "./ValidateCode.vue?vue&type=script&lang=js"
import style0 from "./ValidateCode.vue?vue&type=style&index=0&id=1b570ba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b570ba3",
  null
  
)

export default component.exports